import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FeedbackService } from 'src/app/shared/services';
import { PublicFeedbackService } from 'src/app/shared/services/public-feedback.service';
import { emailValidator } from 'src/app/shared/validators/email.validator';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  translatePath = "public.contacts.";
  public messageForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private publicFeedbackService: PublicFeedbackService,
    private feedbackService: FeedbackService,
  ) {
  }

  ngOnInit() {
    this.messageForm = this.fb.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required, emailValidator]],
      message: [null, [Validators.required]],
    });
  }

  onSubmit() {
    const result = this.messageForm.getRawValue();
    this.publicFeedbackService.postFeedback(result).subscribe(
      _ => {
        this.feedbackService.handleSuccess('email-sent-successfully')
        this.messageForm.reset();
      },
      (error: HttpErrorResponse) => {
        this.feedbackService.handleError(error, this.messageForm);
      }
    );
  }

}
